import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { LoginService } from '../auth-service/login.service';
import { Template } from 'apps/prompt-builder-FE/src/core/interface/template.interface';
import { TemplateService } from '../template-service/template.service';
import { ToastService } from '../toast-service/toast.service';

@Injectable({
  providedIn: 'root'
})
export class ModuleService implements OnDestroy {
  private modules = new BehaviorSubject<MenuItem[]>([]);
  modules$ = this.modules.asObservable();

  private subscriptions: Subscription = new Subscription();

  private allModules: MenuItem[] = [
    // { label: 'Home', icon: 'pi pi-home', routerLink: ['/'], separator: true },
  ];

  private userManagementModule: MenuItem = {
    label: 'User Management',
    icon: 'material:manage_accounts',
    routerLink: ['/user-management']
  };

  private loginService = inject(LoginService);
  private templateService = inject(TemplateService);
  private router = inject(Router);
  private toastService = inject(ToastService);

  constructor() {
    // React to both superAdmin status + templates list
    this.subscriptions.add(
      combineLatest([
        this.loginService.isSuperAdmin$,
        this.templateService.templates$
      ]).subscribe(([isSuperAdmin, templates]) => {
        this.updateModules(isSuperAdmin, templates);
      })
    );
  }

  private updateModules(isSuperAdmin: boolean, templates: Template[]) {
    const currentModules = [...this.allModules];

    if (isSuperAdmin) {
      currentModules.push(this.userManagementModule);
    }

    const templateItems: MenuItem[] = templates.map((tpl: Template) => ({
      label: tpl.name,
      routerLink: ['/template'],
      queryParams: { selectedTemplate: tpl.id },
      templateId: tpl.id // Add template ID for context menu
    }));

    const templatesSection: MenuItem = {
      label: 'Templates',
      icon: 'pi pi-book',
      items: [
        ...templateItems
      ]
    };

    this.modules.next([{ items: [
      ...currentModules,
      {
        label: 'New Template',
        icon: 'pi pi-plus',
        routerLink: ['/template/new']
      }, 
      templatesSection] }]);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}